export default __webpack_public_path__ + "static/laura-c2b2fab6cbfe18b541ec8365567b6093.png";